import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CardSection from "./CardSection";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid } from "@material-ui/core";
import axiosConfig from "../../axiosConfig";

export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();
  const [stripePayLoad, setStripePayLoad] = useState(false);
  const [billingDetails, setBillingDetails] = useState({
    address: {
      city: "",
      country: "",
      line1: "",
      line2: "",
      postal_code: "",
      state: "",
    },
  });

  const brand_id = sessionStorage.getItem("brand_id");

  const handleSubmit = async (event) => {
    setStripePayLoad(true);
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setStripePayLoad(false);
      return;
    }
    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: billingDetails,
    });
    if (error) {
      // console.log("[createPaymentMethod error]", error);
      alert(`Error while filling the form. Error detail - ${error.message}`);
      setStripePayLoad(false);
    } else {
      // console.log("[PaymentMethod]", paymentMethod);
      const paymentMethodId = paymentMethod.id;
      // Create the subscription
      const data = {
        priceId: props.sendPlan.id,
        brandId: brand_id,
        pmId: paymentMethodId,
      };
      axiosConfig
        .post(`/brand/stripe/subscription`, data)
        .then((response) => {
          // console.log("BRAND IS: ", response);
          if (response.data.success === false) {
            // Show error to your customer (e.g., insufficient funds)
            // console.log(response.data.error);
            props.paymentResult(response);
            setStripePayLoad(false);
          } else {
            // The payment has been processed!
            if (response.data.success === true) {
              // console.log(response);
              props.paymentResult(response);
              setStripePayLoad(false);
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          // console.log(err.response);
          //alert('Unexpected Error')
        });
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ width: 600, marginRight: 20, marginBottom: "5%" }}
    >
      <fieldset className="FormGroup">
        <div className="FormRow">
          <label htmlFor="name" className="FormRowLabel">
            Address
          </label>
          <input
            className="FormRowInput"
            label="Address Line One"
            id="addLineTwo"
            type="text"
            placeholder="Address"
            required
            autoComplete="address-line1"
            value={billingDetails.address.line1}
            onChange={(e) => {
              setBillingDetails({
                ...billingDetails,
                address: { ...billingDetails.address, line1: e.target.value },
              });
            }}
          />
        </div>
        <div className="FormRow">
          <label htmlFor="phone" className="FormRowLabel">
            City
          </label>
          <input
            className="FormRowInput"
            label="City"
            id="city"
            type="text"
            placeholder="City"
            required
            autoComplete="address-level2"
            value={billingDetails.address.city}
            onChange={(e) => {
              setBillingDetails({
                ...billingDetails,
                address: { ...billingDetails.address, city: e.target.value },
              });
            }}
          />
        </div>
        <div className="FormRow">
          <label htmlFor="phone" className="FormRowLabel">
            Province
          </label>
          <input
            className="FormRowInput"
            label="Province"
            id="state"
            type="text"
            placeholder="Province"
            required
            autoComplete="address-level1"
            value={billingDetails.address.state}
            onChange={(e) => {
              setBillingDetails({
                ...billingDetails,
                address: { ...billingDetails.address, state: e.target.value },
              });
            }}
          />
        </div>
        <div className="FormRow">
          <label htmlFor="phone" className="FormRowLabel">
            Country
          </label>
          <input
            className="FormRowInput"
            label="Country"
            id="country"
            type="text"
            placeholder="example - CA"
            required
            autoComplete="country"
            value={billingDetails.address.country}
            onChange={(e) => {
              setBillingDetails({
                ...billingDetails,
                address: { ...billingDetails.address, country: e.target.value },
              });
            }}
          />
        </div>
      </fieldset>
      <CardSection />
      {stripePayLoad ? (
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{ marginTop: "4%" }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{ width: "100%", marginLeft: 10 }}
        >
          <Button
            style={{
              width: "100%",
              height: 40,
              marginTop: "5%",
              backgroundColor: "#F6277F",
              boxShadow: "2",
            }}
            type="submit"
            disabled={!stripe}
          >
            <Typography
              style={{
                color: "#FFF",
                fontWeight: "500",
                fontFamily: "Open Sans",
                fontSize: 14,
                textTransform: "none",
              }}
            >
              Subscribe
            </Typography>
          </Button>
        </Grid>
      )}
    </form>
  );
}
